<template>
  <div class="six-imgbox">
    <Loading v-if="isLoading" />
    <NoData v-if="!isLoading && tukuCategory.length === 0" />
    <template v-else>

      <!-- 標頭控制列 -->
      <div v-if="type === 'hk6'" class="six-imgbox__title">
        <div class="six-imgbox__title__left">
          <button class="button-outline" @click="backHK6">
            <span class="button-outline__text">返回列表</span>
          </button>
        </div>
        <div class="six-imgbox__title__content">
          <span class="six-imgbox__title__content__name">{{ tukuInfo.name }}</span>
        </div>
        <div class="imagecontent__header__right">
          <yearPicker v-model="yearValue" :year-data="getThisAndLastYear()" />
        </div>
      </div>

      <!-- 期數的tabber -->
      <template v-if="tukuResultOrPeriodData.length">
        <div class="six-imgbox__control">
          <div class="c8-select">
            <div class="c8-select__content">
              <a
                v-for="(period, periodIndex) in tukuResultOrPeriodData"
                :key="`period-${periodIndex}`"
                class="button-outline c8-select__content__item"
                :class="{'active': isActivePeriod.index === periodIndex}"
                @click.prevent="showImage(periodIndex)"
              ><span class="button-outline__text">{{ period.period }}</span></a>
            </div>
          </div>
        </div>
      </template>

      <!-- 圖片顯示區域 -->
      <NoData v-if="tukuResultOrPeriodData.length === 0" />
      <div v-else-if="!newspaperListComponent" class="six-imgbox__content" style="min-height: 700px;">
        <div v-if="isActivePeriod.index < tukuResultOrPeriodData.length-1" class="content-1__films__previous" @click="nextPeriod">
          <img :src="require('@/assets/style/desktop/img/slider-left.svg')" alt="">
        </div>
        <div v-if="isActivePeriod.index !== 0" class="content-1__films__next" @click="previousPeriod">
          <img :src="require('@/assets/style/desktop/img/slider-right.svg')" alt="">
        </div>
        <div class="content-1__films" style="min-height: 800px;">
          <div class="six-imgbox__img">
            <transition name="fade" mode="out-in">
              <el-image
                :key="tukuResultPath"
                :src="tukuResultPath"
                :preview-src-list="srcList"
              />
              <!-- <img :key="tukuResult[isActivePeriod.index].imgURL" :src="tukuResult[isActivePeriod.index].imgURL" alt=""> -->
            </transition>
          </div>
        </div>
      </div>
      <div v-else class="six-imgbox__content" style="min-height: 700Px">
        <div class="paper-content">
          <PaperImage
            :period="currentPeriod"
            :next-period="nextPeriod"
            :period-data="paperPeriodData"
            :previous-period="previousPeriod"
            :is-active-period="isActivePeriod"
          />
          <component
            :is="newspaperListComponent"
            v-model="overlayMask"
            :cp-id="tukuCategory[0]"
            :period="currentPeriod"
            :cp-code="type"
            :period-data="paperPeriodData"
            :is-active-period="isActivePeriod"
            :next-period="nextPeriod"
            :previous-period="previousPeriod"
          />
        </div>
      </div>
      <div v-if="drawPaperFail" class="draw-paper-fail"></div>
    </template>
    <div v-show="overlayMask" class="overlay-mask">
      <div class="loader"></div>
    </div>
  </div>
</template>
<script>
import yearPicker from '@/components/desktop/common/YearPicker'
import { getTukus, getCategoryName, getNewsPaperPeriod } from '@/api/desktop/images'
import { getThisAndLastYear, imageSearchNoDataMsg } from '@/utils/commonLib'
import dayjs from 'dayjs'
import NoData from '@/components/desktop/common/NoData'
import Loading from '@/components/desktop/common/skeleton/imagesLoading'
import PaperImage from '@/draw-core/drawComponents/PaperImage'
import { newspaperList, paperPollingRefCancel } from '@/draw-core/utils/common'
import am6 from '@/draw-core/liuHe/am6'
import amsf6 from '@/draw-core/liuHe/amsf6'
import amwf6 from '@/draw-core/liuHe/amwf6'
import amff6 from '@/draw-core/liuHe/amff6'
import js6 from '@/draw-core/liuHe/js6'
import sf6 from '@/draw-core/liuHe/sf6'
import ff6 from '@/draw-core/liuHe/ff6'

export default {
  name: 'ImagesList', // 其他六合彩 (分分、三分、極速
  components: {
    yearPicker,
    NoData,
    Loading,
    PaperImage,
    am6,
    amsf6,
    amwf6,
    amff6,
    js6,
    sf6,
    ff6
  },
  props: {
    tukuCategory: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    parentYear: {
      type: String,
      default: ''
    },
    currentTabIndex: {
      type: Number,
      default: 0
    },
    previousTabIndex: {
      type: Number,
      default: 0
    },
    directEnterImageItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extraOptions: [], // 傳一個空陣列把時間篩選器的更多選項拔掉
      isActiveTuku: this.tukuCategory[0], // 預設選擇第一個圖庫
      isActivePeriod: {
        index: null
      }, // 預設選擇最新一期
      tukuInfo: {}, // 存圖庫名字
      tukuResult: [], // 查完圖庫的結果
      defaultTab: dayjs().format('YYYY-MM-DD'), // 預設讓今天高亮
      isLoading: false,
      yearValue: '',
      latestYear: '',
      imageSearchNoDataMsg,
      paperPeriodData: [], // 報紙期數
      newspaperList, // 報紙產圖清單
      overlayMask: false,
      drawPaperFail: false
    }
  },
  computed: {
    srcList() {
      return this.tukuResult.map(el => el.imgURL).reverse()
    },
    tukuResultPath() {
      return this.tukuResultOrPeriodData[this.isActivePeriod.index] ? this.tukuResultOrPeriodData[this.isActivePeriod.index].imgURL : ''
    },
    currentPeriod() { // 目前期號
      return this.tukuResultOrPeriodData?.[this.isActivePeriod.index]?.period || ''
    },
    tukuResultOrPeriodData() {
      return this.newspaperList.includes(this.type) ? this.paperPeriodData : this.tukuResult
    },
    newspaperListComponent() { // 要顯示的圖庫彩種
      return this.newspaperList.includes(this.type) ? this.type : ''
    }
  },
  watch: {
    yearValue: {
      handler: async function(newValue, oldValue) {
        if (this.type === 'hk6' && oldValue && newValue !== oldValue) {
          await this.getTukus({
            categoryID: this.isActiveTuku,
            count: '30',
            year: newValue
          })
          this.resetActivePeriodIndex()
        }
      }
    },
    currentPeriod: {
      handler: async function(newVal) {
        await this.$store.dispatch('lottery/setCurrentNewspaperPeriod', {
          period: newVal,
          cpCode: this.type
        })
        this.$store.dispatch('lottery/setPaperFetchMessage', '')
      }
    }
  },
  async created() {
    this.yearValue = this.parentYear || getThisAndLastYear()[0].toString()
    let query = {}
    query = {
      categoryID: this.tukuCategory[0],
      count: '30'
    }
    if (this.type === 'hk6') {
      query.year = this.yearValue
    }
    await this.getCategoryName(this.tukuCategory)
    if (this.newspaperList.includes(this.type)) {
      await this.getImagePeried(query)
    } else {
      await this.getTukus(query)
    }

    this.setActivePeriodIndex()

    await this.$store.dispatch('lottery/setCurrentNewspaperPeriod', {
      period: this.currentPeriod,
      cpCode: this.type
    })
  },
  methods: {
    async getCategoryName(query) {
      const [data, err] = await getCategoryName(query)
      if (err) {
        console.error(`[error]:`, err)
        return
      }
      this.tukuInfo = data.find(item => item.id === query[0]) || {}
    },
    // 取得圖庫的中文名稱 ↑
    async getTukus(query) {
      this.isLoading = true
      const [data, err] = await getTukus(query)
      this.isLoading = false
      if (err) {
        console.error(`[error]:`, err)
        return
      }
      this.tukuResult = data
    },
    showImage(val) {
      paperPollingRefCancel(this)
      this.isActivePeriod.index = val
      this.updatePeriod(this.currentPeriod)
    },
    backHK6() {
      this.$emit('backHK6', true)
      this.$emit('resetHK6')
    },
    previousPeriod() {
      this.isActivePeriod.index -= 1
      this.updatePeriod(this.currentPeriod)
    },
    nextPeriod() {
      this.isActivePeriod.index++
      this.updatePeriod(this.currentPeriod)
    },
    getThisAndLastYear,
    setActivePeriodIndex() {
      const { period, action, authorization } = this.$route.query
      const activePeriod = this.tukuResultOrPeriodData.findIndex(item => item.period === period)
      if (action === 'draw' && authorization !== '') { // 自動產圖判斷(虛擬機只戳電腦版)
        if (activePeriod < 0) { // 找不到期數就顯示
          this.drawPaperFail = true // chromedp 用
          return
        }
        this.isActivePeriod.index = activePeriod || null
      }

      // 路由沒有期數
      if (!period) {
        this.resetActivePeriodIndex()
        return
      }

      // 網址直接進入 且 期數不符合 就顯示警告訊息
      if (this.previousTabIndex === null && activePeriod < 0) {
        alert(this.imageSearchNoDataMsg)
      }

      // 從選單進入
      if (this.previousTabIndex !== null && this.previousTabIndex !== this.currentTabIndex) {
        this.resetActivePeriodIndex()
        return
      }

      const currentIndex = Math.max(activePeriod, 0)
      this.isActivePeriod.index = currentIndex
      this.updatePeriod(this.currentPeriod)
    },

    resetActivePeriodIndex() {
      this.isActivePeriod.index = 0
      this.updatePeriod(this.currentPeriod)
    },

    showNoDataAlert() {
      alert(this.imageSearchNoDataMsg)
    },
    updatePeriod(currentPeriod = '') {
      // 網址更新 彩種、期號
      let query = {}
      query = {
        lotteryCode: this.type,
        period: currentPeriod
      }
      if (this.type === 'hk6') {
        query = {
          lotteryCode: this.type,
          categoryID: this.tukuCategory[0],
          year: this.yearValue,
          period: currentPeriod
        }
      }
      this.$router.push({ query })
    },
    async getImagePeried(query) {
      const [data, err] = await getNewsPaperPeriod(query)
      if (err) {
        console.error(`[error]:`, err)
        return
      }
      this.paperPeriodData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.imagecontent {
  border: #b7b7b7 1px solid;
  &__header {
    display: flex;
    padding: 1rem 10px;
    min-height: 1rem;
    justify-content: space-between;
    align-items: center;
    border-bottom: #b7b7b7 1px solid;
    &__left {
      width: 15%;
      font-size: 1rem;
    }
    &__title {
      width: 70%;
      font-size: 2rem;
      text-align: center;
    }
    &__right {
      width: 15%;
      font-size: 1rem;
    }
  }
  &__select {
    padding: 1rem 10px;
    min-height: 1rem;
    border-bottom: #b7b7b7 1px solid;
    &__item {
      border-radius: 10%;
      margin-right: 10px;
      padding: 5px;
      background-color: #d6d6d6;
      border: #a0a0a0 1px solid;
      &--active {
        background-color: #178aff;
      }
    }
  }
  &__contant {
    width: 1140px;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-self: center;
    &--fluid {
      min-width: 100%;
    }
  }
}
.six-imgbox{
display: flex;
flex-direction: column;
width: 100%;
  &__title{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: solid 1px #EBEBEB;
    &__left{
      flex: 1;
      display: flex;
      justify-content: flex-start;
      .button-outline{
        border: none;
      }
    }
    &__content{
      display: flex;
      justify-content: center;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      max-width: 600px;
    }
    .imagecontent__header__right{
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }

    &__right{
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      &__text{
        margin: 0 8px;
      }
    }
  }
  &__control{
    min-height: 50px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #EBEBEB;
    position: relative;
    &__icon{
      position: absolute;
      width: 16px;
      height: 16px;
      right: 16px;
      top: 16px;
      cursor: pointer;
      >img{
        width: 100%;
      }
    }
  }
  &__content{
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: relative;
    .content-1__films{
      border: 0;
    }
    .six-imgbox__img{
      width: 100%;
      text-align: center;
      > img {
        max-width: 100%;
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>

